import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import '../../services/GlobalVariables';

const API_URL = global.SET_API_URL + 'openingClosing/';

// Thunks
export const getTodayClosingData = createAsyncThunk(
  'closing/getTodayClosingData',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(API_URL + 'closing/today-data', payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getLastOpenTill = createAsyncThunk(
  'closing/getLastOpenTill',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(API_URL + 'opening/last-open', payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createClosing = createAsyncThunk(
  'closing/createClosing',
  async (closingData, { rejectWithValue }) => {
    try {
      const response = await axios.post(API_URL + 'closing/create', closingData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getClosingHistory = createAsyncThunk(
  'closing/getClosingHistory',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(API_URL + 'closing/history', payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getEstimatedStockPreview = createAsyncThunk(
  'closing/getEstimatedStockPreview',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(API_URL + 'closing/estimated-stock', payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Initial State
const initialState = {
  todayData: null,
  closingData: null,
  history: [],
  estimatedStock: null,
  loading: false,
  error: null,
  success: false
};

// Slice
const closingSlice = createSlice({
  name: 'closing',
  initialState,
  reducers: {
    clearClosing: (state) => {
      state.closingData = null;
      state.error = null;
      state.success = false;
    }
  },
  extraReducers: (builder) => {
    // getTodayClosingData
    builder
      .addCase(getTodayClosingData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTodayClosingData.fulfilled, (state, action) => {
        state.loading = false;
        state.todayData = action.payload.data;
        state.error = null;
      })
      .addCase(getTodayClosingData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.todayData = null;
      });

    // createClosing
    builder
      .addCase(createClosing.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createClosing.fulfilled, (state, action) => {
        state.loading = false;
        state.closingData = action.payload.data;
        state.success = true;
      })
      .addCase(createClosing.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });

    // getClosingHistory
    builder
      .addCase(getClosingHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(getClosingHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.history = action.payload.data;
      })
      .addCase(getClosingHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // getEstimatedStockPreview
    builder
      .addCase(getEstimatedStockPreview.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEstimatedStockPreview.fulfilled, (state, action) => {
        state.loading = false;
        state.estimatedStock = action.payload.data;
      })
      .addCase(getEstimatedStockPreview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.estimatedStock = null;
      });
  }
});

export const { clearClosing } = closingSlice.actions;
export default closingSlice.reducer;
